/* eslint-disable max-lines-per-function */

import Answer from "../Answer"
import CountdownCircle from "../CountdownCircle"
import PointsView from "../PointsView"
import {AnswerWrapper,
  AnswersAndCountdown,
  CountdownBubble,
  Panel,
  PointsViewWrapper,
  Question,
  ScoreTab,
  ScoreValue,
  expand,
  expandX,
  expandY,
  fitToParent,
  slideUpBehind} from "./styled"
import React from "react"
import styled from "styled-components"
import whiteQKlogo from "../../../../media/ard-quizkit-logo-white.svg"

const PointsViewLogo = styled.img.attrs({
  src: whiteQKlogo
})`
  width: 50%;
  height: 100%;
  display: flex;
  margin: auto;
`

const PointsViewLogo2 = styled.img`
  width: 50%;
  height: 100%;
  display: flex;
  margin: auto;
`

const QuizPanel = ({
  colors,
  countdown,
  bannerImage,
  isRevealed,
  question,
  skinName,
  fonts,
}) => (
  <Panel bgColor={colors.primary}>

      <Question fontColor={colors.primaryFont}>
      { question.question }
    </Question>

      <AnswersAndCountdown>
      <CountdownBubble>
          <CountdownCircle
          angle={isRevealed ? 360 : 360 - ((countdown.timeRemaining / countdown.startTime) * 360)}
          bgColor={colors.background}
          sectorColor={colors.variables}
        />
          <PointsViewWrapper>
          {
            !isRevealed && (
              <PointsView
                fontColor={colors.primaryFont}
                points={Math.trunc(countdown.timeRemaining)}
              />
            )
          }
          {isRevealed && skinName === "Quiz Kit" && <PointsViewLogo />}
          {isRevealed && skinName !== "Quiz Kit" && <div />}
          </PointsViewWrapper>
        </CountdownBubble>

      {
        question.answers.map((answer, i) => {

          const orientation = ["left", "left", "right", "right"][i]
          const gridArea = ["top-left", "bottom-left", "top-right", "bottom-right"][i]

          return (
            <AnswerWrapper
              gridArea={gridArea}
              key={answer.answer}
              orientation={orientation}
              fontName={fonts.secondaryFont}
            >
              <Answer
                answer={answer.answer}
                colors={{
                  correct : {
                    answerBar: colors.correctBackground,
                    font: colors.primaryFont,
                    percentCorrectBar: colors.correctForeground,
                  },
                  incorrect: {
                    answerBar: colors.secondary,
                    font: colors.secondaryFont,
                    percentCorrectBar: colors.incorrectColor,
                  },
                  neutral : {
                    answerBar: colors.secondary,
                    font: colors.secondaryFont,
                    percentCorrectBar: colors.incorrect,
                  },
                  selected: {
                    answerBar: colors.highlight,
                    font: colors.secondaryFont,
                    percentCorrectBar: null,
                  },
                }}
                isCorrect={answer.correct}
                isRevealed={isRevealed}
                numberAnswered={answer.selectedByPlayers}
                orientation={orientation}
              />
            </AnswerWrapper>
          )
        })
      }
    </AnswersAndCountdown>
    </Panel>
)

export default QuizPanel
